<template>
	<section>
		<header-simple :spaceTop="false" :title="$t('Locale')" :subtitle="'Information about the locale user has seletected.'"></header-simple>

		<div class="sk-locales">
			<shape :class="['sk-locales__item', {'sk-locales__item--active': isActive('en-gb')}]" src="/static/svg/flags/uk.svg" @click.native="onClick('en-gb')" />
			<shape :class="['sk-locales__item', {'sk-locales__item--active': isActive('fr')}]" src="/static/svg/flags/fr.svg" @click.native="onClick('fr')" />
			<shape :class="['sk-locales__item', {'sk-locales__item--active': isActive('pt')}]" src="/static/svg/flags/pt.svg" @click.native="onClick('pt')" />
		</div>
	</section>
</template>

<script>
import HeaderSimple from '@/modules/ui/HeaderSimple'
export default {
	components: {
		HeaderSimple
	},
	methods: {
		isActive(lang) {
			return lang === this.$i18n.locale
		},
		onClick (lang) {
			this.$i18n.locale = lang
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title('Locale')
		})
	}
}
</script>

<style scoped>
.sk-locales {
	display: flex;
	align-items: center;
	justify-content: flex-start;
}
.sk-locales__item {
	width: 32px;
	height: 32px;
	opacity: 0.25;
	transition: opacity 300ms;
	cursor: pointer;
	margin: 10px 3px;
}

.sk-locales__item:hover,
.sk-locales__item:active,
.sk-locales__item--active {
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/user/profile/UserProfileLocale.vue